import { Component, HostListener, OnInit } from '@angular/core';
import { HeaderComponent } from "../../components/header/header.component";
import { SidebarLeftComponent } from "../../components/sidebar-left/sidebar-left.component";
import { MapComponent } from "../../components/map/map.component";
import { CardInfoComponent } from "../../components/card-info/card-info.component";
import { AnagraficaModalComponent } from "src/app/components/anagrafica-modal/anagrafica-modal.component";
import { Footer } from "src/app/components/footer/footer";
import { SidebarDataService } from 'src/app/services/sidebar-data.service';

@Component({
  selector: 'app-home-pages',
  templateUrl: './home-pages.component.html',
  styleUrls: ['./home-pages.component.css'],
  imports: [HeaderComponent, SidebarLeftComponent, MapComponent, CardInfoComponent, AnagraficaModalComponent, Footer],
  standalone: true
})
export class HomePagesComponent implements OnInit {

constructor(private sidebarData: SidebarDataService) {}

  ngOnInit() {
        if (!this.sidebarData.hasBaseData) {
      this.sidebarData.initAllData().subscribe();
    }
  }

}
